var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcConference = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4 10.932a1 1 0 0 1 1 1c0 3.466 3.059 6.404 7 6.404s7-2.938 7-6.404a1 1 0 1 1 2 0c0 4.713-4.104 8.404-9 8.404-4.897 0-9-3.69-9-8.404a1 1 0 0 1 1-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 19a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1m-.133-16C10.317 3 9 4.313 9 6.008v4.984C9 12.688 10.317 14 11.867 14h.266C13.683 14 15 12.688 15 10.992V6.008C15 4.313 13.683 3 12.133 3zM7 6.008C7 3.277 9.146 1 11.867 1h.266C14.855 1 17 3.277 17 6.008v4.984C17 13.724 14.855 16 12.133 16h-.266C9.146 16 7 13.724 7 10.992z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 7a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1m-1 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})));
export default SvgIcConference;